export enum ESpinParametersType {
    NORMAL = 'normal',
    FAST = 'fast',
    TURBO = 'turbo',
    REGULATED_2S = 'regulated_2s'
}

export enum ETurboModeLevels {
    NORMAL,
    FAST,
    TURBO
}

export type SpinSpeed = keyof typeof ETurboModeLevels;

export interface ISpinParameters {
    type: ESpinParametersType;
    desiredVelocity: number;
    minimalSpinDuration: number;
    symbolsShownAfterResponsePerReel: number[];
    tensionDurationForEachConsecutiveReel: number[];
    afterTensionDurationForEachConsecutiveReel: number[];
    accelerationTime: number;
    decelerateFrom: number;
    startYOffset: number;
    startYOffsetTime: number;
    stopYOffset: number;
    stopYOffsetTime: number;
    tensionVelocityModifier: number;
    quickStopVelocityModifier: number;
    delayAfterWonTension: number;
    delayAfterLostTension: number;
    allowQuickStopOnTension: boolean;
    allowQuickStopOnFGTension: boolean;
    skipTensionPerReel: boolean;
    startTensionSoundOnEachReel: boolean;
    startTensionSoundOnEachReelFG: boolean;
    fullTensionDuration: number;
}

export interface IAutoPlayState {
    isEnabled: boolean;
    isSuspended: boolean;
    currentCount: number;
    totalCount: number;
    lossLimit: number;
    delayBeforeSpin: number;

    // ADVANCED AUTOPLAY SETTINGS
    stopOnAnyWin?: boolean;
    stopOnBigWin?: boolean;
    stopOnFreeGameStart?: boolean;
    stopOnFreeGameEnd?: boolean;
    stopOnSingleWinExeeds?: number;
}

export interface IFreeGamesAutoPlayState extends IAutoPlayState {}

export interface ITurboModeState {
    active: boolean;
    baseGameLevel: ETurboModeLevels;
    specialGameLevel: ETurboModeLevels | undefined;
    animationsSpeedPerLevel: number[];
    winSpeedPerLevel: number[];
    deactivateTurboInFG: boolean;
}
